<template>
    <div class="enameledWireMateBarView">
        <m-assembly-table :formData="formData"
                        :columns="tableColumns"
                        :data="tableData"
                        :currentPage="settings.currentPage"
                        :pageSize="settings.pageSize"
                        :settings="settings"
                        :tableButtons="tableButtons"
                        :tableTitle="tableTitle"
                        :loading="loading"
                        :total="settings.total"
                        :row-class-name="rowClassName"
                        @onSubmit="onSubmit"
                        @onPageSizeChange="onPageSizeChange"
                        @onCurrentPageChange="onPageChange"
                        @onSelectionChange="onSelectionChange"
                        ref="mateForm">
        </m-assembly-table>
        <Modal v-model="uploadModal" :width="500" class="enameledWireModal" :mask-closable="false" @on-cancel="handleCancel">
            <h3 slot="header" class="clearfix">
               <span class="pull-left" style="line-height: 45px;font-size: 16px;">{{$t('enameledWireMateBarView.t1')}}</span>
               <!-- <div class="step-header">
                    <div class="step-bar">
                      <div class="step-bar-active" id="step-bar-active"></div>
                    </div>
                    <ul>
                      <li class="active"><span></span>
                        <p>{{$t('enameledWireMateBarView.t2')}}</p></li>
                      <li v-if="current >= 1" class="active"><span></span>
                        <p>{{$t('enameledWireMateBarView.t3')}}</p></li>
                      <li v-else><span></span>
                        <p>{{$t('enameledWireMateBarView.t3')}}</p></li>
                      <li v-if="current >= 2" class="active"><span></span>
                        <p>{{$t('enameledWireMateBarView.t4')}}</p></li>
                      <li v-else><span></span>
                        <p>{{$t('enameledWireMateBarView.t4')}}</p></li>
                    </ul>
                </div> -->
            </h3>
            <div v-if="current === 0" class="step-container">
                <p class="form-item-tip">{{$t('enameledWireMateBarView.t5')}}</p>
                <div class="text-center">
                    <Button type="primary" @click="handleDowloadTemplate()">{{$t('enameledWireMateBarView.t2')}}</Button>
                </div>
            </div>
            <div v-else-if="current === 1" class="step-container">
                <Upload
                    ref="upload1"
                    :accept="['xls', 'xlsx']"
                    :format="['xls', 'xlsx']"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :action="uploadFileUrl">
                    <Button type="ghost" icon="ios-cloud-upload-outline" :loading="this.uploadFileLoading">{{$t('enameledWireMateBarView.t6')}}</Button>
                </Upload>
            </div>
            <div v-else-if="current === 2" class="step-container">
                <div class="form-item-tip">
                    <h3 v-if="downInportResultObj.sourceToken">{{$t('enameledWireMateBarView.t7')}}<span style="cursor:pointer;color:red" @click="downInportResult">{{$t('enameledWireMateBarView.t8')}}</span>{{$t('enameledWireMateBarView.t9')}}</h3>
                    <span>{{excelImportTips}}</span>
                </div>
            </div>
            <div slot="footer">
                <m-button v-if="current > 0 && current < 2" @click="prev">{{$t('enameledWireMateBarView.t10')}}</m-button>
                <m-button v-if="current < 2" type="primary" @click="next">{{$t('enameledWireMateBarView.t11')}}</m-button>
                <m-button v-else type="success" @click="handleComplete">{{$t('enameledWireMateBarView.t12')}}</m-button>
            </div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
export default {
    name: 'enameledWireMateBarView',
    components: {mAssemblyTable},
    data() {
        return {
            supplierInfo: {},
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0,
                needSetTable: true
            },
            formData: {
                row: 3,
                items: [
                    {
                        title: this.$t('enameledWireMateBarView.t13'), // 库存组织
                        placeholder: this.$t('enameledWireMateBarView.t14'), // 请选择库存组织
                        value: '',
                        field: 'orgCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('enameledWireMateBarView.t15') // 组织不能为空
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t16'),
                        placeholder: this.$t('enameledWireMateBarView.t17'),
                        value: '',
                        field: 'deliveryBarcode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t18'), // 绑定状态
                        placeholder: this.$t('enameledWireMateBarView.t19'), // 请选择绑定状态
                        value: '',
                        field: 'status',
                        disabled: false,
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('enameledWireMateBarView.t19') // 绑定状态不能为空
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        options: {
                            multiple: false,
                            values: [
                                {label: this.$t('enameledWireMateBarView.t20'), value: 'B'},
                                {label: this.$t('enameledWireMateBarView.t21'), value: 'P'},
                                {label: this.$t('enameledWireMateBarView.t22'), value: 'PB'}
                            ]
                        },
                        type: 'select'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t23'),
                        placeholder: this.$t('enameledWireMateBarView.t24'),
                        value: '',
                        field: 'itemTagBarcode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t25'),
                        placeholder: this.$t('enameledWireMateBarView.t26'),
                        value: '',
                        field: 'innerTagBarcode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t27'), // 上传日期
                        isDouble: true,
                        value: moment(new Date()).subtract(29, 'd')._d,
                        field: 'startDate',
                        type: 'datePicker',
                        style: 'width:100%',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('enameledWireMateBarView.t28')
                            },
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd',
                            options: {
                                disabledDate(date){}
                            }
                        },
                        change: (dateObj, time) => {
                        }
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t27'),
                        hide: true,
                        value: new Date().getTime(),
                        field: 'endDate',
                        type: 'datePicker',
                        style: 'width:100%',
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('enameledWireMateBarView.t28')
                            },
                            validator: (rule, value, callback, source, options) => {
                                let start = this.formData.items[5].value;
                                let end = this.formData.items[6].value;
                                if ((new Date(end).getTime() - new Date(start).getTime()) / 86400000 > 30) {
                                    callback([this.$t('enameledWireMateBarView.t29')])
                                    return false;
                                } else {
                                    callback([]);
                                }
                            }
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd'
                        }
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t30'),
                        placeholder: this.$t('enameledWireMateBarView.t31'),
                        value: '',
                        field: 'itemCode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t32'),
                        placeholder: this.$t('enameledWireMateBarView.t45'),
                        value: '',
                        field: 'itemBatch',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    }
                ],
                buttons: {
                    showSubmit: true,
                    showReset: true,
                    showSearch: true,
                    layout: {
                        span: 24,
                        push: 8
                    }
                }
            },
            tableButtons: {
                systemButtons: [],
                customButtons: [
                    {
                        name: '',
                        label: this.$t('enameledWireMateBarView.t1'), // 条码上传
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: () => {
                            this.uploadModal = true
                        }
                    },
                    {
                        name: '',
                        label: this.$t('enameledWireMateBarView.t33'), // 绑定条码
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: () => {
                            this.bindingBarcode();
                        }
                    },
                    {
                        name: '',
                        label: this.$t('enameledWireMateBarView.t34'), // 删除条码
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: true,
                        click: () => {
                            this.beforeDeleteTag();
                        }
                    }
                ]
            },
            tableColumns: {
                columns: [
                    {
                        title: this.$t('enameledWireMateBarView.t35'),
                        type: 'selection',
                        width: 30,
                        align: 'center'
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t23'), // 送货标签条码号
                        key: 'itemTagBarcode',
                        align: 'left',
                        sortable: true,
                        tooltip: true,
                        minWidth: 120
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t25'), // 内箱条码号
                        key: 'innerTagBarcode',
                        align: 'left',
                        sortable: true,
                        tooltip: true,
                        minWidth: 120
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t30'), // 物料编码
                        key: 'itemCode',
                        align: 'left',
                        sortable: true,
                        tooltip: true,
                        minWidth: 130
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t36'), // 数量
                        key: 'quantity',
                        align: 'right',
                        minWidth: 90
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t32'), // 生产批次
                        key: 'itemBatch',
                        align: 'left',
                        sortable: true,
                        minWidth: 90
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t37'), // 轴重/轴数
                        key: 'rollerQuantity',
                        align: 'right',
                        minWidth: 60
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t38'), // 颜色
                        key: 'colour',
                        align: 'center',
                        minWidth: 50
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t39'), // 包装规格/明细
                        key: 'packingDetails',
                        align: 'left',
                        render: (h, params) => {
                            return h('Tooltip', {
                                props: {
                                    content: params.row.packingDetails,
                                    placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, params.row.packingDetails);
                        },
                        minWidth: 100
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t16'), // 送货单条码号
                        key: 'deliveryBarcode',
                        align: 'left',
                        tooltip: true,
                        minWidth: 100
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t18'), // 绑定状态
                        key: 'status',
                        align: 'center',
                        minWidth: 60,
                        render: (h, params) => {
                            let val = '';
                            if (params.row.status === 'B') {
                                val = this.$t('enameledWireMateBarView.t20');
                            } else if (params.row.status === 'P') {
                                val = this.$t('enameledWireMateBarView.t21');
                            } else if (params.row.status === 'PB') {
                                val = this.$t('enameledWireMateBarView.t22');
                            }
                            return h('span', val);
                        }
                    },
                    {
                        title: this.$t('enameledWireMateBarView.t27'), // 上传日期
                        key: 'creationDate',
                        align: 'center',
                        sortable: true,
                        minWidth: 80,
                        render: (h, params) => {
                            let day = params.row.creationDate ? moment(params.row.creationDate).format('YYYY-MM-DD') : '';
                            return h('span', day);
                        }
                    }
                ]
            },
            tableData: [],
            tableTitle: '',
            loading: false,
            condition: {},
            selection: [],
            /** 上传 */
            uploadModal: false,
            current: 0,
            uploadFileUrl: '',
            downInportResultObj: {
                sourceToken: '',
                fileName: ''
            },
            uploadFileLoading: false,
            vendorId: null,
            vendorCode: null,
            userName: null,
            mdmCode: null,
            excelImportTips: ''
        };
    },
    watch: {},
    methods: {
        rowClassName(row, index) {
            return row.status === 'PB' ? 'rowRedColor' : '';
        },
        /** 按照快码GSC_JD_ORG获取机电事业部库存组织 */
        getCUX_JD_ORG() {
            return new Promise((resolve, reject) => {
                axios.get('/gscint/sys/sysParam/queryDictionaryData?dictCode=CUX_JD_ORG&isValid=Y').then(res => {
                    if (res.data.success) {
                        resolve(res.data.data);
                    } else {
                        reject();
                    }
                }).catch(err => {
                    console.log('err:', err);
                })
            });
        },
        onSelectionChange (selection) {
            this.selection = selection;
            if (this.selection.length > 0) {
                this.tableButtons.customButtons[2].disabled = false;
            } else {
                this.tableButtons.customButtons[2].disabled = true;
            }
        },
        onPageChange: function (currentPage, pageSize, condition) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页容量改变时触发 */
        onPageSizeChange: function (currentPage, pageSize, condition) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSubmit(current, pageSize, condition) {
            this.condition = condition;
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        /** 搜索 */
        onSearch: function () {
            let params = {};
            this.formData.items.forEach((item) => {params[item.field] = item.value;});
            params.startDate = params.startDate ? moment(params.startDate).format('YYYY-MM-DD') : '';
            params.endDate = params.endDate ? moment(params.endDate).format('YYYY-MM-DD 23:59:59') : '';
            params.vendorCode = this.vendorCode;
            params.pageNum = this.settings.currentPage;
            params.pageSize = this.settings.pageSize;
            this.loading = true;
            this.tableData = [];
            this.selection = [];
            let url = '/gscint/uploadTag/getUploadTag';
            axios.post(url, params).then(
                res => {
                    let data = res.data;
                    this.loading = false;
                    if (data.success) {
                        this.tableData = res.data.data.list || [];
                        this.settings.total = res.data.data.total || 0;
                        this.onSelectionChange(this.selection);
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: data.msg
                        });
                    }
                }
            ).catch(() => {
                this.showErrorTips();
            });
        },
        /** 条码上传start */
        handleCancel() {
            this.current = 0;
        },
        handleComplete() {
            this.current = 0;
            this.uploadModal = false;
            var bar = document.querySelector('#step-bar-active');
                bar.style.width = 0 + 'px';
        },
        prev() {
            this.current--;
            var bar = document.querySelector('#step-bar-active');
                bar.style.width = this.current * 125 + 'px';
        },
        next() {
            if (this.current < 1) {
                this.current++;
                var bar = document.querySelector('#step-bar-active');
                bar.style.width = this.current * 125 + 'px';
            }
        },
        // handleBeforeFileUpload(file) {
        //     this.batchLoadInFile = file;
        //     return false;
        // },
        handleSuccess (res, file, fileList) {
            if (res.success) {
                if (['0', '-1'].includes(res.data.code)) {
                    this.excelImportTips = res.data.msg;
                    this.downInportResultObj = {
                        fileName: file.name || this.$t('enameledWireMateBarView.t41'),
                        sourceToken: res.data.datas
                    };
                    this.current++;
                    var bar = document.querySelector('#step-bar-active');
                        bar.style.width = this.current * 125 + 'px';
                } else {
                    this.$Modal.warning({
                        title: this.$t('common.warn'),
                        content: res.data.msg
                    });
                    this.uploadModal = false;
                    this.$refs['upload1'].clearFiles();
                    this.current--;
                }
            } else {
                this.$refs['upload1'].clearFiles();
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: res.errorCode
                });
            }
        },
        handleError () {
            this.uploadFileLoading = false;
            this.$Message.error(this.$t('common.upload_error'));
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('enameledWireMateBarView.t42')
            });
        },
        handleDowloadTemplate() {
            let isEnglish = this.$i18n.locale === 'en-US';
            let docId = this.isPro() ? '182ed50fdab71f1e9e0b84548de91c06' : '182ed503e5bbb0fcb278cd94e5badca0';
            if (!isEnglish) {
                docId = this.isPro() ? '18353b43561610c54a65e85404a8f0ff' : '18353b3ba67aef13ccd4e0741d092d78';
            }
            window.open(`/gscint/supplierfile/downloadFile?docId=${docId}`);
        },
        downInportResult () {
            window.open(`/gscint/uploadTag/receipt?sourceToken=${this.downInportResultObj.sourceToken}&fileName=${this.$t('enameledWireMateBarView.t41')}`);
        }, // 条码上传end

        /** 绑定条码 */
        bindingBarcode() {
            this.$router.push({
                path: '/purchaseDistribution/enameledWireMateBarBind',
                query: {}
            });
        },
        /** 删除条码 */
        beforeDeleteTag() {
            this.$Modal.confirm({
                title: this.$t('common.warn'),
                content: this.$t('enameledWireMateBarView.t43'),
                onOk: () => {
                    setTimeout(() => {
                        this.deletTag();
                    }, 300);
                }
            })
        },
        deletTag() {
            let params = [];
            this.selection.forEach((item) => {
                params.push(item.id);
            })
            this.loading = true;
            let url = '/gscint/uploadTag/deleteTag';
            axios.post(url, params).then(
                res => {
                    let data = res.data.data;
                    this.loading = false;
                    if (data.success) {
                        if (data.code === '1') {
                            this.$Modal.success({
                                title: this.$t('common.warn'),
                                content: this.$t('enameledWireMateBarView.t44')
                            });
                            this.onSearch();
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: data.msg
                            });
                            this.onSearch();
                        }
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: data.msg
                        });
                    }
                }
            ).catch(() => {
                this.showErrorTips();
            });
        }
    },
    mounted() {
        const { vendorCode, vendorId, userName, mdmCode } = JSON.parse(window.localStorage.supplierInfo);
        this.vendorCode = vendorCode;
        this.vendorId = vendorId;
        this.userName = userName;
        this.mdmCode = mdmCode;
        this.uploadFileUrl = `/gscint/uploadTag/excelImport?txnDate=${moment(new Date()).format('YYYY-MM-DD')}&vendorId=${this.vendorId}&vendorCode=${this.vendorCode}&operatorName=${this.userName}&mdmCode=${this.mdmCode}`;
        this.getSRMInvLovListNew((data) => {
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = data.map((item) => {
                return {
					...item,
                    label: item.organizationName,
                    value: item.organizationCode,
                };
            });
        });
    }
};
</script>

<style lang='less' scoped>
    .step-header {
        width: 310px;
        padding: 0 10px 0 30px;
        float: right;
        position: relative;
        overflow: hidden;
        margin-right: 10px;
        ul {
            padding: 0;
            width: 375px;
            float: left;
            position: relative;
            li {
                list-style-type: none;
                float: left;
                position: relative;
                width: 125px;
                &.active {
                    span {
                        background: #2d8cf0;
                    }
                    p {
                        color: #333333;
                    }
                }
                p {
                    font-weight: bold;
                    margin-top: 5px;
                    font-size: 13px;
                    color: #999999;
                    float: left;
                    position: relative;
                    left: -50%;
                    text-align: center;
                    width: 125px;
                }
                span {
                    position: relative;
                    height: 20px;
                    width: 20px;
                    border-radius: 10px;
                    background: #ccc;
                    left: -10px;
                    display: block;
                }
            }
        }
    }
    
    .step-bar {
        width: 250px;
        height: 13px;
        background: #ccc;
        position: absolute;
        border-radius: 12px;
        top: 4px;
        overflow: hidden;
    }
    
    .step-bar-active {
        width: 0px;
        height: 13px;
        background: #2d8cf0;
    }
    .form-item-tip{
        text-align: center;
        margin-bottom: 10px;
    }
    .step-container{
        width: 450px;
        margin: 0 auto;
        padding:10px 0;
        .success-info{
            font-weight: 700;
            font-size: 14px;
            padding: 30px 0 50px 0;
            border-bottom: 1px solid #ccc ;
            color: #2A3C59;
        }
        .success-tip{
            font-weight: 600;
            font-size: 12px;
            padding: 15px 0 20px 0;
            color: #666;
        }
    }
    /deep/ .enameledWireMateBarView .m-table .rowRedColor td{
        background-color: #FED0CB;
    }
</style>
<style lang='less'>
    .enameledWireModal {
        .m-modal-body {
            padding: 0;
        }
        .m-modal-footer {
            padding: 0px 18px 10px;
        }
    }
</style>